__turbopack_context__.v({
  "action": "header-global-action-module__GFOXkq__action",
  "actionActive": "header-global-action-module__GFOXkq__actionActive",
  "iconBox": "header-global-action-module__GFOXkq__iconBox",
});
